import { render, staticRenderFns } from "./mainTitle.vue?vue&type=template&id=756bbdd8&scoped=true&"
var script = {}
import style0 from "./mainTitle.vue?vue&type=style&index=0&id=756bbdd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756bbdd8",
  null
  
)

export default component.exports